// extracted by mini-css-extract-plugin
export default {"image":"BookResult_image__7ftlY","title":"BookResult_title__BllsV"};